import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faHeart, faPhone, faCommentDots, faUser } from '@fortawesome/free-solid-svg-icons';

const MobileBottomNav = ({ user, setShowCallModal, location, closeAll, mobileNavStyle, navItemStyle, callButtonStyle }) => {
  return (
    <div id="liber-mobile-nav-fixed" className="mobile-only-nav" style={mobileNavStyle}>
      <Link to="/" onClick={closeAll} style={navItemStyle(location.pathname === '/')}>
        <FontAwesomeIcon icon={faHome} />
        <span>Գլխավոր</span>
      </Link>
      
      <Link to="/favorites" onClick={closeAll} style={navItemStyle(location.pathname === '/favorites')}>
        <FontAwesomeIcon icon={faHeart} />
        <span>Սիրված</span>
      </Link>
      
      <div style={{ flex: 1, display: 'flex', justifyContent: 'center', position: 'relative' }}>
<button 
  type="button" 
  onClick={() => setShowCallModal(true)} 
  style={callButtonStyle}
  // ✅ Դնում ենք ուղիղ հայերեն անունը, որ Lighthouse-ը տեսնի ու հանգստանա
  aria-label="Զանգահարել" 
>
  <FontAwesomeIcon icon={faPhone} aria-hidden="true" />
</button>
      </div>
      
      <Link to="/contact" onClick={closeAll} style={navItemStyle(location.pathname === '/contact')}>
        <FontAwesomeIcon icon={faCommentDots} />
        <span>Կապ</span>
      </Link>
      
      <Link to={user ? "/profile" : "/user-login"} onClick={closeAll} style={navItemStyle(location.pathname.includes('profile') || location.pathname.includes('login'))}>
        <FontAwesomeIcon icon={faUser} />
        <span>Իմ էջը</span>
      </Link>
    </div>
  );
};

export default MobileBottomNav;